import type { ReactNode } from 'react'
import { Link } from "react-router-dom"
import aiShoppingAgent from '@/assets/images/ai-shopping-agent.jpg'
import aiOnlineShopping from '@/assets/images/ai-online-shopping-agents.jpg'
import shoppingExperience from '@/assets/images/shopping-experience.jpg'
import shoppingTools from '@/assets/images/shopping-tool.jpg'
import roiAi from "@/assets/images/roi-ai.jpg"
import aiHunter from "@/assets/images/ai-price-hunter.jpg";
import { normalizeTerm } from '@/utils/helper'
import bsProduct from "@/assets/images/beyondstyle-product.png"
import americanMerchants from '@/assets/images/american-merchants.jpg'
import priceHunterV2 from "@/assets/images/price-hunter-v2.jpg"
import priceHunterv2Product from '@/assets/images/price-hunter-v2-product.png'
import agentCheckout from '@/assets/images/agent-checkout.jpg'
import omniAgent from "@/assets/images/omni-agent.jpg"
import Nestor from '@/assets/images/nestor.jpg'
import ThreePredictions from '@/assets/images/three-predictions.jpeg'
import AgenticInterfaces from "@/assets/images/agentic-interfaces.jpg"
import AiCommerce from "@/assets/images/ai-commerce.jpeg"
import ShopGeni from "@/assets/images/ShopGeni.jpeg"
import AIShoppingAgents from "@/assets/images/AI-Shopping-Agents.jpeg"
import EraOfAgenticCommerce from "@/assets/images/era-of-agentic-commerce.jpg"
export interface Article {
  id: string;
  title: string;
  subtitle: string;
  backgroundColor: string;
  publishAt: string;
  image: string;
  content: ReactNode;
}

const articles: Article[] = [{
    title: "The Era of Agentic Commerce: How Cloudstore AI is Re-platforming Fashion Retail for 2026",
    backgroundColor: "#f1cebc",
    subtitle: `The Shift: When "Browsing" Becomes "Buying" As we move through 2026, the traditional e-commerce funnel is being dismantled. We’ve entered the age of Agentic Commerce—a world where AI agents, content platforms, and high-traffic publishers are no longer just "referral" sources but active transaction hubs.`,
    publishAt: "Published on March 13, 2026",
    image: EraOfAgenticCommerce,
    content: (
      <>
        <p>
            <strong>The Shift: When "Browsing" Becomes "Buying"</strong>
        </p>
        <p>As we move through 2026, the traditional e-commerce funnel is being dismantled. We’ve entered the age of <strong>Agentic Commerce</strong>—a world where AI agents, content platforms, and high-traffic publishers are no longer just "referral" sources but active transaction hubs.</p>
        <p>For years, publishers and fashion discovery sites faced a "leaky bucket" problem: they would inspire a purchase, only to lose the customer (and the data) the moment they clicked a redirect link to an external retailer.</p>
        <p>
            <strong>Cloudstore AI</strong> was built to plug that leak.
        </p>
        <p>
            <strong>Cloudstore AI: Turning Any Interface into a Storefront</strong>
        </p>
        <p>The core mission of Cloudstore AI is to provide the "commerce nervous system" for any platform with an audience. Instead of building a complex e-commerce backend from scratch, publishers and brands are now integrating the <strong>Cloudstore AI solution</strong> to enable instant, on-site transactions.</p>
        <p>The solution rests on two massive pillars designed for 2026's high-speed retail environment:</p>
        <p>
            <strong>1. The Catalog API: 20 Million SKUs in Real-Time</strong>
        </p>
        <p>In the old model, expanding your product supply meant months of vendor negotiations and technical manual uploads. With Cloudstore AI’s <strong>Catalog API</strong>, platforms get instant access to <strong>20 million US fashion SKUs.</strong></p>
        <p>This isn't just a static list; it’s a "live" supply chain. Whether your audience is looking for boutique luxury or mass-market staples, our API ensures that inventory is synced, prices are real-time, and every product featured is actually available for purchase.</p>
        <p>
            <strong>2. Universal Checkout: The End of Redirects</strong>
        </p>
        <p>The biggest conversion killer in 2026 remains the "redirect." Every time a user is forced to leave your site to complete a payment, conversion rates drop by as much as 40%.</p>
        <p>Cloudstore AI’s <strong>Universal Checkout API</strong> creates a frictionless, full-funnel experience. It allows users to:</p>
        <ol>
          <li>
            Discover a product.
          </li>
          <li>
            Add to cart.
          </li>
          <li>
            Complete the transaction.
          </li>
          <li>
            <strong>All without ever leaving your ecosystem.</strong>
          </li>
        </ol>
        <p>This allows the host site to retain <strong>100% of the customer data and GMV</strong>, moving from a low-margin affiliate model to a high-margin transactional powerhouse.</p>
        <p>
            <strong>Why 2026 is the Year of the "Transactional Powerhouse"</strong>
        </p>
        <p>With the recent launch of the <strong>Universal Commerce Protocol (UCP)</strong> and the mainstreaming of AI shopping agents, the web is becoming one giant, interconnected shopping mall.</p>
        <p>Cloudstore AI has already processed over <strong>$1B in GMV</strong>, proving that when you remove the friction between <span style={{fontStyle: 'italic'}}>seeing</span> and <span style={{fontStyle: 'italic'}}>buying</span>, the revenue follows. For companies sitting on high-value traffic, the question is no longer "how do we get more clicks?" but "how do we capture the transaction ourselves?"</p>
        <p>
            <strong>Future-Proof Your Platform</strong>
        </p>
        <p>The era of passive content is over. Whether you are a fashion publisher, a social platform, or a next-gen discovery tool, your growth in 2026 depends on your ability to execute commerce.</p>
        <p><strong>Cloudstore AI</strong> is the infrastructure that makes this possible. By combining the world's deepest fashion catalog with a universal, on-site checkout, we are giving the power back to the platforms where discovery actually happens.</p>
        <p><strong>Ready to turn your traffic into a transactional engine?</strong> Explore the Cloudstore AI API documentation or schedule a demo today to see how we’re building the future of Agentic Commerce.</p>
      </>
    ),
   },{
    title: "A Year of Building and Empowering AI Shopping Agents",
    backgroundColor: "#F5F5F5",
    subtitle: `Building and Empowering AI Shopping Agents: Our 2025 Journey. A decade ago, we founded BorderX Lab with a vision to make global commerce automatic, intelligent, and interactive. From the beginning, we developed automated solutions—data crawlers, order bots, logistics tracking systems, email parsers, and Bot Generated Content (now known as AIGC)—to streamline ecommerce operations.`,
    publishAt: "Published on December 29, 2025",
    image: AIShoppingAgents,
    content: (
      <>
        <p>
            <strong>Building and Empowering AI Shopping Agents: Our 2025 Journey</strong>
        </p>
        <p>A decade ago, we founded BorderX Lab with a vision to make global commerce automatic, intelligent, and interactive. From the beginning, we developed automated solutions—data crawlers, order bots, logistics tracking systems, email parsers, and Bot Generated Content (now known as AIGC)—to streamline ecommerce operations.</p>
        <p>With the emergence of large language models in the early 2020s, we recognized transformative opportunities to advance ecommerce automation and intelligence. In 2024, we established our strategic priority: building and empowering AI shopping agents. As 2025 draws to a close, we're pleased to share our progress.</p>
        <p>
            <strong>Building AI Shopping Agents</strong>
        </p>
        <p>We developed three LLM-powered AI shopping agents in 2025:</p>
        <p>
            <span style={{fontStyle: 'italic'}}>AI Product Collector</span> automatically extracts and structures product information from any Product Detail Page URL. This technology powers Beyond, our cross-border ecommerce mobile app, enabling Chinese consumers to purchase any product from America with seamless data integration.
        </p>
        <p>
            <span style={{fontStyle: 'italic'}}>AI Price Hunter</span> identifies the lowest available price for any product across the internet. We deployed this agent in <a href="https://beyondstyle.us" target="_blank">BeyondStyle</a>, our price-discovery shopping assistant serving American consumers in the fashion and sports categories.
        </p>
        <p>
            <span style={{fontStyle: 'italic'}}>ShopGeni</span> is our product-discovery chatbot that excels in scenarios like outfit recommendations and gift suggestions. In December, we embedded ShopGeni on every Product Detail Page of BeyondStyle, creating an interactive shopping experience similar to Amazon's Rufus or Walmart's Sparky.
        </p>
        <p>
            <strong>Advancing Agentic Payment and Agentic Checkout Solutions</strong>
        </p>
        <p>We believe agentic payment innovation presents a significant opportunity to lower transaction costs, facilitate micro-transactions, expand digital commerce, and reduce or eliminate chargebacks. Throughout 2025, major players including Visa, Mastercard, PayPal, Stripe, and Google rolled out agentic payment protocols. We have been experiencing low transaction cost and few/no chargeback in payment space in Asian countries for a decade. We hope American innovators can catch up now.</p>
        <p>We're actively participating in this transformation. Our partnership with PayOS enables agentic payment for Visa and Mastercard on BeyondStyle, aligned with <a href="https://corporate.visa.com/en/sites/visa-perspectives/newsroom/visa-partners-complete-secure-agentic-transactions.html" target="_blank">Visa's announcement</a> near year-end. We've also expanded our agentic checkout partnerships beyond our longstanding collaboration with some players including Zinc, which has powered Beyond and BeyondStyle for years, to include several new partners in 2025. We look forward to additional collaborations in 2026.</p>
        <p>
            <strong>Empowering AI Shopping Agents Through CloudStore AI</strong>
        </p>
        <p>Since 2023, we've used CloudStore AI products to empower AI shopping agents. In 2025, we made substantial advances to this platform:</p>
        <p>Our three Core APIs—Catalog API, Checkout API, and Logistics Tracking API—enable AI shopping agents to operate global ecommerce businesses while focusing on workflow innovation and user acquisition. Together, these APIs have processed over $1 billion in transactions across more than 5 million successful orders, handling the complexities of fashion, sports, and outdoor ecommerce at scale. We've significantly enhanced our API capabilities, particularly improving Checkout API quality by supporting diverse scenarios for new clients.</p>
        <p>We launched Search API and Visual Search API in 2025, providing tools for image-based recommendations such as apparel matching from photos. We enhanced search quality through advanced technologies including embedded search.</p>
        <p>We expanded our AI shopping agent toolkit with the launch of AI Price Hunter and ShopGeni. ShopGeni enables any ecommerce site to offer product-discovery chat functionality, proving particularly valuable for infrequent and long-tail product discovery.  ShopGeni can empower any ecommerce site to have a product discovery chatbot, just like Amazon’s Rufus and Walmart’s Sparky.</p>
        <p>
            <strong>Looking Ahead</strong>
        </p>
        <p>As we enter the final days of 2025, the AI shopping agent landscape continues to evolve rapidly. Success in this space requires domain expertise, sustainable business models, and clear value propositions. We're excited to continue building and empowering AI shopping agents in 2026, and we look forward to expanding our partnerships as we advance this journey together.</p>
      </>
    ),
   },{
    title: "ShopGeni: The Future of Agentic Shopping Is Here",
    backgroundColor: "#A3F4FF",
    subtitle: `From Clicking to Conquering: How ShopGeni Turns Browsers into Buyers on Autopilot. For thirty years, e-commerce has asked the same exhausting question: “What exactly are you looking for today?”`,
    publishAt: "Published on December 26, 2025",
    image: ShopGeni,
    content: (
      <>
        <p>
            From Clicking to Conquering: How ShopGeni Turns Browsers into Buyers on Autopilot<br/>
            For thirty years, e-commerce has asked the same exhausting question:
        </p>
        <p>“What exactly are you looking for today?”</p>
        <p>Filters. Search bars. Infinite scrolling. 8.8 abandoned carts out of every 10.</p>
        <p>
            We built faster websites, smarter recommendations, and one-click checkout… and conversion rates barely moved.<br/>
            The interface was never the problem.<br/>
            The paradigm was.
        </p>
        <p>
            Welcome to Agentic Commerce, and meet the agent leading the charge:<br/>
            ShopGeni by BorderX Lab, the first production-ready AI Shopping Agent that doesn’t assist the shopper.
        </p>
        <p>
          <strong>What Actually Happens When ShopGeni Takes Over</strong><br/>
          A real customer conversation (recorded last week):
        </p>
        <p>
            Customer (voice or text):<br/>
            “Heading to Tokyo for 9 days in March with my wife. We want to look good but pack light. Budget $1,500 total for both of us, including shoes.”
        </p>
        <p>
            ShopGeni (30 seconds later):<br/>
            Three Tokyo travel-tested sets, each focused on lightweight comfort, style, and packability. All sets feature moisture-wicking and easy-care pieces to handle urban exploring, variable March weather, and extended days on your feet. The color stories emphasize classic neutrals—black, navy, khaki—with pops of blue and streamlined accents, offering mix-and-match versatility for a chic, functional travel wardrobe. Stay adventure-ready and stylish on every Tokyo street!<br/>
            Total, 3 outfits for you and 3 outfits for your wife.
        </p>
        <p>Show the outfits on screen.</p>
        <p>Customer: “No2 for man, No3 for woman.”</p>
        <p>
            ShopGeni:<br/>
            Total: $1,347 after bundle discounts.<br/>
            Carry-on only. Ships tomorrow. Approve?”
        </p>
        <p>Customer: “Perfect. Approve.”</p>
        <p>
            No product pages visited.<br/>
            No size charts.<br/>
            No “Add to cart → Continue shopping → Apply coupon → Checkout” dance.<br/>
            The agent negotiated bulk pricing across three partnered brands, applied store credits, checked inventory in real time, and pre-filled shipping forms.<br/>
            That is Agentic Commerce.
        </p>
        <p>
            <strong>Forward-thinking merchants</strong> — from luxury fashion groups to big-box electronics chains — are already thinking of ShopGeni because it flips every legacy metric on its head:
        </p>
        <p>
            AOV ↑ 100% (the agent upsells and bundles better than any human)<br/>
            Conversion rate ↑ 2× (most “carts” never exist; the agent closes on intent)<br/>
            Return rate ↓ 40% (ShopGeni has virtual try-on, reads reviews, compares fit models, and only buys what statistically works)<br/>
            Customer support tickets ↓ 70% (the agent handles size swaps, delays, everything)
        </p>
        <p>
            <strong>Retailers Must Capture Agentic Traffic or Risk Losing Share</strong><br/>
            AI agents will naturally gravitate toward merchants who surface structured, rich, machine-readable data. Retailers who prepare now will become “first-class citizens” in the agentic landscape, capturing more visibility, more clicks, and more conversions.
        </p>
        <p>Contact us via email: <a href="mailto:contact@borderxlab.com">contact@borderxlab.com</a></p>
      </>
    ),
   },{
    title: "BorderX Lab ShopGeni Redefines AI Commerce",
    backgroundColor: "#F5F5F5",
    subtitle: `BorderX Lab’s ShopGeni Redefines AI Commerce: Achieves Full-Cycle Autonomous Shopping via Strategic Partnership with Visa and PayOS`,
    publishAt: "Published on December 19, 2025",
    image: AiCommerce,
    content: (
      <>
        <p>
            <iframe 
                width="560" 
                height="315" 
                src="https://www.youtube.com/embed/w4ZBzNgHppE"
                title="YouTube video player"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                referrerPolicy="strict-origin-when-cross-origin" 
                allowFullScreen>
            </iframe>
        </p>
        <p>
          <strong>BorderX Lab’s ShopGeni Redefines AI Commerce: Achieves Full-Cycle Autonomous Shopping via Strategic Partnership with Visa and PayOS</strong>.
        </p>
        <p>
          <strong>Silicon Valley, CA — December 19, 2025</strong> —  BorderX Lab, a Silicon Valley-based leader in AI-driven ecommerce, today announced a major milestone in the evolution of "Agentic Commerce." Its flagship AI shopping agent, ShopGeni, has successfully achieved a full-cycle, autonomous shopping experience—from product discovery,  price discovery,  to secure agentic checkout.
        </p>
        <p>This breakthrough aligns with Visa’s latest industry forecast, which predicts that 2026 will be the breakout year for agentic commerce, with millions of consumers expected to shift from AI-assisted searching to AI-completed purchasing.</p>
        <p>
          The report also identified BorderX Lab’s partners and clients as key drivers in the transition to AI-agent-driven payments. As part of this ecosystem, <a href="https://beyondstyle.us" target="_blank">BeyondStyle</a> , a premier fashion and lifestyle platform powered by BorderX Lab technology, has integrated ShopGeni to provide a seamless "Find-to-Buy" journey for global consumers.
        </p>
        <p>
          <strong>Closing the Loop: From Search to Instant Checkout</strong>
        </p>
        <p>
           While many AI tools are limited to recommendations, ShopGeni is designed to act. By leveraging BorderX Lab’s proprietary "ShopAgent" technology and integrating with PayOS—a leading payment infrastructure provider highlighted in Visa’s latest pilot—ShopGeni now enables Agentic Checkout across hundreds of major retail websites, including Jomashop and other global merchants.
        </p>
        <p>
            "2025 marks the end of an era where consumers have to navigate the friction of manual checkouts alone," said Albert Shen, CEO at BorderX Lab. "Through ShopGeni, we are not just helping users find deals; we are executing the entire transaction securely. Our partnership with Visa Intelligent Commerce and PayOS ensures that every agent-initiated purchase is secure."
        </p>
        <p>
          <strong>Real-World Impact on BeyondStyle and CloudStore AI</strong>
        </p>
        <p>
          The technology is already live and transforming the user experience on partner platforms:
        </p>
        <ol>
          <li>
            <a href="https://beyondstyle.us" target="_blank">BeyondStyle</a> : Serving as a digital personal shopping assistant, BeyondStyle uses ShopGeni to track millions of fashion, sports and outdoor products. Users can now move from an AI-curated "Daily Outfit" to a completed purchase in a single flow, with the agent automatically applying coupons and managing the agentic checkout.
          </li>
          <li>
            <a href="https://nubestore.ai" target="_blank">CloudStore AI</a> : As a tool kit to empower AI shopping agents, CloudStore AI provides the essential API infrastructure (Catalog, Checkout, and Logistics) that allows other AI developers to build their own agentic shopping experiences using BorderX Lab's proven stack.
          </li>
        </ol>
        <p>
          <strong>The Future of Agentic Commerce</strong>
        </p>
        <p>
          According to Visa’s research, nearly half of U.S. consumers already use AI for shopping tasks. BorderX Lab is positioned at the forefront of this shift, moving beyond the "experimental" phase into mainstream production. By 2026, the company expects millions of transactions to be handled by AI shopping agents like ShopGeni, reducing cart abandonment for retailers and saving countless hours for consumers.
        </p>
        <p>
          <a href="https://www.youtube.com/watch?v=w4ZBzNgHppE" target="_blank">Video: https://www.youtube.com/watch?v=w4ZBzNgHppE</a>
        </p>
        <p>
          <a href="https://corporate.visa.com/en/sites/visa-perspectives/newsroom/visa-partners-complete-secure-agentic-transactions.html" target="_blank">Visa press release</a>
        </p>
        <p>
            <strong>About BorderX Lab</strong> The mission of BorderX Lab is to make global ecommerce automatic, intelligent, and interactive. BorderX Lab builds and empowers AI shopping agents. Backed by leading venture capital firms at the post-Series B stage, BorderX Lab partners with top-tier merchants, payment, and logistics service providers in the world.
        </p>
        <p><strong>Media Contact:</strong></p>
        <p>Jessica Zhuang, <a href="mailto:jessica@borderxlab.com">jessica@borderxlab.com</a></p>
      </>
    ),
   },
  {
    title: "From HTML to Agentic Interfaces: The Next Evolution of E-Commerce",
    backgroundColor: "#CBB9FF",
    subtitle: `Today marks Labor Day in the United States — a time when people relax and prepare for the upcoming fall season. As we enter the final quarter of 2025, it's an opportune moment to reflect on what has been widely predicted as "the year of AI agents."`,
    publishAt: "Published on September 26, 2025",
    image: AgenticInterfaces,
    content: (
      <>
        <p>
          The example shown in Google’s AP2 framework (see: <a href="https://youtu.be/yLTp3ic2j5c" target="_blank">video link</a>) offers a glimpse into the emerging world of <strong>agentic shopping</strong>.
        </p>
        <p>
         Looking ahead, it’s clear that shopping will increasingly shift toward AI-powered shopping agents. For younger consumers in particular, or in scenarios where traditional online shopping falls short—such as <strong>complex bundled purchases</strong> (outfits, flight + hotel packages) or <strong>time-consuming tasks</strong> (research, price comparisons)—shopping agents will become the natural entry point for traffic.
        </p>
        <p>This shift will fundamentally change how merchants present their products. Instead of designing for human consumers, they’ll need to design for shopping agents. Whether the standard becomes Google’s A2A, MCP, or another protocol, the reality is that merchants will face a new kind of “storefront redesign”—this time not in HTML, but in agentic interfaces. And it won’t just be a handful of merchants: it will be an industry-wide transformation, comparable to the transition from websites to apps in the last era of e-commerce.
        </p>
        <p>
          This transformation brings enormous demand, which we see unfolding in three stages:
        </p>
        <p>
          <strong>1. Merchant-driven agentic storefronts.</strong>
        </p>
        <p>
           Merchants will need technical support to complete this transition. Some will build in-house IT teams, while others will look for solution providers. The opportunity here is to provide a <strong>generalizable SaaS service</strong>—tools that allow merchants to easily build agentic storefronts while integrating seamlessly with their existing backends (product/ordering systems, CRM, logistics, etc.). Think of this as a “Shopify for agentic shopping.”
        </p>
        <p>
          <strong>2. Low-friction interim solutions.</strong>
        </p>
        <p>
          Change won’t happen overnight. Most merchants will wait for the market to mature before committing fully. In the meantime, they’ll need lightweight solutions to capture agent-driven traffic with minimal investment. A platform provider could step in here—extracting product data directly from merchants’ existing websites/apps and handling agentic traffic on their behalf. For merchants, this is almost invisible. Today, BorderXLab’s <Link to="/">CloudStore AI</Link> already provides such a model.
        </p>
        <p>
          <strong>3. Aggregators of merchant data.</strong>
        </p>
        <p>
           In an agentic shopping world, consumers will still want to compare across multiple merchants. While shopping agents can query multiple merchants, this is inefficient. A more effective approach is to aggregate merchant data in advance, index it, and optimize search/retrieval to boost conversion. This allows faster, smarter interactions between agents and platforms—again, similar to how BorderXLab’s <Link to="/">CloudStore AI</Link> works today.
        </p>
        <p>
          At BorderXLab, we believe agentic shopping is an <strong>inevitable trend</strong>, and we’re fully committed to embracing it. Our AI strategy follows four steps:
        </p>
        <ol>
          <li>
            <strong>Build shopping agents</strong> to participate in the emerging ecosystem. Our current focus is on scenarios that traditional e-commerce cannot handle well—such as multi-item outfits, styling recommendations, and sizing advice. Our first shopping agent has been launched on BeyondStyle.us to help accelerate growth.
          </li>
          <li>
            <strong>Scale the CloudStore AI product</strong> to support more shopping agents. We’re actively developing an MCP interface to improve integration.
          </li>
          <li>
            <strong>Enhance CloudStore AI capabilities</strong>—integrating agentic payments, onboarding more merchants, and advancing search algorithms—evolving toward meeting both interim and aggregator needs.
          </li>
          <li>
            <strong>Launch SaaS services</strong> for merchants at the right time, offering them the tools to build their own agentic storefronts.
          </li>
        </ol>
        <p>
          The shift to agentic shopping is just beginning, and BorderXLab is ready to help shape this new era.
        </p>
      </>
    ),
   },
   {
    title: "The State of AI Shopping Agents: Three Predictions for the Future of Agentic Commerce",
    backgroundColor: "#F5F5F5",
    subtitle: "Today marks Labor Day in the United States — a time when people relax and prepare for the upcoming fall season. As we enter the final quarter of 2025, it's an opportune moment to reflect on what has been widely predicted...",
    publishAt: "Published on September 1, 2025",
    image: ThreePredictions,
    content: (
      <>
        <p>
          Today marks Labor Day in the United States — a time when people relax and prepare for the upcoming fall season. As we enter the final quarter of 2025, it's an opportune moment to reflect on what has been widely predicted as "the year of AI agents."
        </p>
        <p>
          With three quarters behind us, the AI agent landscape has indeed evolved at breakneck speed, particularly in sectors like AI coding agents (remember the Windsurf drama?). As innovators and practitioners in the AI shopping agent and agentic commerce space, we've built three LLM-based AI shopping agents and empowered numerous others throughout this transformative year.
        </p>
        <p>
          Based on our hands-on experience and market observations, here are three predictions that will shape the future of AI shopping agents and agentic commerce.
        </p>
        <p>
          <strong>1. Agentic ecommerce ecosystem has really come into play in 2025. AI shopping agents, Large Language Models, payment companies, commerce tools are actively collaborating to transform digital commerce. Brands and retailers should step up now, design a strategy to serve AI shopping agents well and grab agentic commerce opportunities.</strong>
        </p>
        <p>
          The agentic ecommerce ecosystem has truly come into its own in 2025. AI shopping agents, large language models, payment companies, and commerce tools are actively collaborating to fundamentally transform digital commerce. Brands and retailers should step up now, design a strategy to serve AI shopping agents well, and grab agentic commerce opportunities. Execution is now essential.
        </p>
        <p>
          Throughout 2025, we've partnered with numerous AI shopping agent startups, each bringing unique value propositions: including personal styling assistants, virtual shopping avatar shopping,intelligent gift recommendation systems such as <a target="_blank" href="https://www.beyondstyle.us/nestor">Giftly</a>, and advanced price discovery tools such as <a target="_blank" href="https://www.beyondstyle.us/ai-price-hunter/2025/best-august-28th-deals-from-ralph-lauren-arcteryx-michael-kors-and-more?id=2c9e8b8698ef95f50198f01eb2a70000">AI Price Hunter</a>.
        </p>
        <p>
          Some AI shopping agents provide comprehensive end-to-end shopping journeys, while others focus on specialized point solutions. We're even seeing traditional publishers and content creators integrate AI shopping agents with checkout capabilities, creating seamless experiences for their audiences.
        </p>
        <p>
          The payment ecosystem has embraced this transformation wholeheartedly. Major players including Visa, Mastercard, and PayPal all announced significant agentic commerce initiatives in Q2, driving innovation in payment processing for AI agents. Meanwhile, LLM foundation model companies continue advancing their agentic capabilities — ChatGPT Operator being such an example.
        </p>
        <p>
          Our CloudStore products exemplify this ecosystem evolution, providing AI shopping agents with comprehensive fashion and sports ecommerce capabilities including catalog management, checkout processing, logistics tracking, and visual search APIs.
        </p>
        <p>
          Despite this progress, many brands and retailers have remained on the sidelines due to economic uncertainties and trade policy fluctuations throughout 2025. As market conditions stabilize, this hesitation represents both a risk and an opportunity.
        </p>
        <p>
          The agentic commerce transformation will eclipse the impact of the gig economy revolution (think DoorDash, Uber, and Instacart). In the future, brands and retailers may find themselves serving AI superintelligence rather than human customers exclusively (think some retail stores or restaurants which serve gig economy apps exclusively.) 
        </p>
        <p>
          Brands and retailers has a few questions to think, and plan and execute accordingly. How should brands and retailers position themselves to work effectively with AI shopping agents or bots in general? What security and safety protocols are needed for AI agent payments? How can pre-sales and post-sales customer service adapt to serve both human and AI customers?
        </p>
        <p>
          Brands and retailers must develop comprehensive agentic commerce strategies now to remain competitive.
        </p>
        <p>
          <strong>2. Domain-specific AI agents will dominate over super agents for the next three years</strong>
        </p>
        <p>
          While super agents like Manus generated significant buzz early in 2025 with promises of handling everything from presentation creation to travel booking, our experience suggests a different path forward.
        </p>
        <p>
          Each domain requires unique workflows, optimization strategies, and performance metrics. Achieving high completion rates, high accuracy, low cost, and low latency demands deep domain-specific optimization that super agents simply cannot provide across multiple verticals simultaneously.
        </p>
        <p>
          Based on our experience building and empowering AI shopping agents, we're confident that domain-specific AI agents—whether in shopping, coding, or other specialized areas—will deliver the most meaningful business impact over the next three years.
        </p>
        <p>
          Specialized AI agents can optimize workflows for specific industry requirements, develop deep domain expertise and knowledge bases, integrate seamlessly with existing industry tools and platforms, and deliver measurably performance in their focus areas.
        </p>
        <p>
          <strong>3. The Era of building impactful AI agents and generating sound unit economics has arrived.</strong>
        </p>
        <p>
          The days of burning through venture capital while spinning compelling narratives are ending. The market is demanding AI agents that deliver measurable business impact with sustainable economics.
        </p>
        <p>
          Over the past two years, we've witnessed impressive fundraising rounds and reports of rapid ARR growth. However, many of these success stories lack fundamental unit economics. Some companies operate with negative gross margins, relying entirely on venture funding to subsidize unsustainable business operations. Market correction is already underway. A recent MIT report revealed that "despite $30–40 billion in enterprise investment into GenAI, 95% of organizations are getting zero return" based on measurable P&L impact.
        </p>
        <p>
          Business leaders are reevaluating their AI strategies with increased focus on tangible business outcomes. For AI agents to sustain this innovation wave, they must demonstrate clear value and maintain sound unit economics.
        </p>
        <p>
          We should at least do the following three things and enhance your AI agents' business value iteratively: 
        </p>
        <ol>
          <li>
            <strong>Conduct Value Assessments</strong>: Regularly evaluate your AI agents' value proposition for consumers (B2C) or clients (B2B)
          </li>
          <li>
            <strong>Gather Authentic Feedback</strong>: Engage with customers directly to understand real impact and areas for improvement
          </li>
          <li>
            <strong>Optimize Business Models</strong>: <br/>
            <ul>
                <li>Consumer applications: Consider advertising (CPM/CPC), commission-based (CPA) or subscription models</li>
                <li>Enterprise applications: Explore monthly fees, revenue sharing, or usage-based pricing</li>
            </ul>
          </li>
        </ol>
        <p>
          <strong>Looking Ahead: The Future of Agentic Commerce</strong>
        </p>
        <p>
          As we enter the final quarter of 2025, the AI shopping agent landscape is poised for continued evolution. The companies that will thrive are those that combine domain expertise, sustainable business models, and clear value propositions.
        </p>
        <p>
          The agentic commerce revolution is here. The question isn't whether AI shopping agents will transform digital commerce, but how quickly businesses can innovate to serve this new paradigm effectively.
        </p>
        <p>
          For those building in this space, focus on creating specialized, valuable solutions with sound economics. For brands and retailers, the time for strategic preparation is now. The future belongs to those who embrace the agentic commerce transformation today.
        </p>
      </>
    ),
   },
   {
    title: "BorderX Lab Launches Nestor—  The AI Shopping Agent That Will Replace the Luxury Cart Forever",
    backgroundColor: "#DCFF9B",
    subtitle:
      "BorderX Lab today buries the “add-to-cart” button and crowns a single sentence as the new gateway to luxury.  Meet Nestor, the AI shopping agent that turns any whim into a delivered parcel, starting with a gift-finder and graduating to the...",
    publishAt: "San Francisco, August 14, 2025",
    image: Nestor,
    content: (
      <>
        <p>
          BorderX Lab today buries the “add-to-cart” button and crowns a single sentence as the new gateway to luxury. <br />Meet Nestor, the AI shopping agent that turns any whim into a delivered parcel, starting with a gift-finder and graduating to the de-facto front door of global fashion.
        </p>
        <p>
          The old path is pain: open seven luxury sites, convert currencies, guess duties, close the tab in despair. <br /> Nestor’s path is one line: “Find me a luxury silver clutch around $1,200 that lands in Shanghai in two weeks.” Thirty seconds later the clutch is bought, insured, tracked, and gift-wrapped.
        </p>
        <p>
          Under the hood sits a Universal SKU Cortex of 10 million luxury and fashion SKUs refreshed every 90 seconds, a Borderless Wallet that handles Apple Pay, crypto or digital yuan while calculating duties to the cent, an Expert Whisperer that answers “Is this shearling traceable?” with certificates and three ethical alternatives, and a Price-Lock Insurance that refunds the difference if a better price appears within 30 days.
        </p>
        <p>
          But the real disruption starts now. Snap a runway photo and receive the full look shoppable in 60 seconds. Pre-order limited drops milliseconds after reveal while Nestor hedges unsold units on secondary markets. Ask aloud “surprise my wife on our anniversary” and watch curated options, gift notes and same-day delivery deploy across 147 cities. Every purchase displays its carbon footprint and offers one-tap offset.
        </p>
        <p>
          “Nestor isn’t another app—it’s the last search bar fashion will ever need.”  <br />
          — Albert Shen, CEO, BorderX Lab
        </p>
        <p>
          Experience the shift at nestor.beyondstyle.us: whisper “Birthday gift for a watch collector who already owns a Daytona” and watch Nestor surface an unworn 1972 Tiffany-signed Patek 3700, insured, 11 % below market, ready to ship with Face ID.
        </p>
        <p>
          The shopping cart is gone. Long live the conversation.
        </p>
        <p>
          FOR IMMEDIATE RELEASE <br /> 
          Contact: <a href="mailto:contact@borderxlab.com">contact@borderxlab.com</a>
        </p>
      </>
    ),
  },
  {
    title: "BorderX Lab Unveils OmniAgent Solution on Nubestore.ai, Redefining AI-Powered eCommerce",
    backgroundColor: "#F5F5F5",
    subtitle:
      "Sunnyvale, CA – August 5, 2025 – BorderX Lab, a leader in AI-driven cross-border e-commerce, today announced the launch of its groundbreaking OmniAgent Solution and CloudStore...",
    publishAt: "Published on August 12, 2025",
    image: omniAgent,
    content: (
      <>
        <p>
          <strong>Sunnyvale, CA – August 5, 2025</strong> – BorderX Lab, a leader in AI-driven cross-border e-commerce, today announced the launch of its groundbreaking OmniAgent Solution and CloudStore platform on Nubestore.ai. This industry-first suite of AI Shopping Agents and system APIs is designed to transform the online shopping experience by driving customer acquisition, increasing conversion rates, boosting average order value (AOV), extending user engagement, and enabling cross-selling opportunities.
        </p>
        <p>
          Building on the success of its $20 million Series B funding round led by Kleiner Perkins, Hillhouse and CBC, BorderX Lab has leveraged its expertise in AI and big data to create Nubestore.ai, the OmniAgent Solution, a comprehensive set of tools tailored for global retailers and shoppers. The platform integrates seamlessly with over 2,000 brands and 10 million SKUs, fulfilled 5M packages, $1B GMV, offering unmatched personalization and efficiency in eCommerce.
        </p>
        <p><strong>Key Features of the OmniAgent Solution and CloudStore:</strong></p>
        <ul>
          <li>
            <strong>AI Gift Finder Nestor</strong>: A LLM based context-aware recommendation engine that delivers personalized product and gift suggestions based on user preferences and shopping scenarios, enhancing the shopping experience with tailored recommendations.
          </li>
          <li>
            <strong>AI Price Hunter</strong>: A global price comparison tool, based on LLM that searches and recommends the lowest prices for fashion products worldwide, ensuring shoppers get the best deals across Nubestore.ai catalog.
          </li>
          <li>
            <strong>Image Search API</strong>: A visual search tool that allows users to snap a photo of an item and instantly find relevant products, simplifying the discovery process without requiring product names or descriptions.
          </li>
          <li>
            <strong>Catalog API with real-time coupon technology</strong>: Seamlessly integrates with a robust supply chain, connecting merchants to over 2,000 brands and 10 million SKUs. The API supports coupon-enabled purchases, streamlining inventory management and product discoverability.
          </li>
          <li>
            <strong>Checkout API</strong>: Enables a frictionless one-click checkout experience by automatically applying the best available coupons, increasing conversion rates and customer satisfaction.
          </li>
          <li>
            <strong>Logistics API</strong>: Optimizes order fulfillment and delivery processes, ensuring efficient and reliable shipping for merchants and customers alike.
          </li>
        </ul>
        <p>
          “OmniAgent & CloudStore Solution represents a leap forward in how AI can empower both shoppers and merchants,” said Xuehua Shen, CEO of BorderX Lab. “By combining advanced AI Shopping Agents with powerful APIs, we’re enabling retailers to attract new customers, boost conversions, and deliver a seamless, personalized shopping experience. Our platform is built to scale globally, and we’re excited to see it redefine e-commerce.”
        </p>
        <p>
          The OmniAgent Solution is powered by Nubistore.ai, BorderX Lab’s innovative platform that integrates with leading e-commerce ecosystems, including Shopify-powered businesses, to provide real-time product data and insights. This ensures merchants can offer high-quality, relevant products while shoppers benefit from unbiased recommendations and streamlined purchasing.
        </p>
        <p>
          <strong>Benefits for Merchants:</strong>
        </p>
        <ul>
          <li>
            <strong>Increased Conversion Rates</strong>: The AI-driven tools improve customer engagement and drive purchases, with BorderX Lab’s platform historically achieving a 3x improvement in conversion rates for international shoppers.
          </li>
          <li>
            <strong>Enhanced Product Visibility</strong>: By indexing products in Nubestore.ai’s catalog, merchants increase their chances of being recommended, leveraging detailed product data for better relevance.
          </li>
          <li>
            <strong>Seamless Integration</strong>: Powerful APIs access allows merchants to build custom shopping experiences, with a dedicated dashboard providing insights into search and shopping trends.
          </li>
          <li>
            <strong>Global Reach</strong>: The platform connects merchants to a worldwide audience, building on BorderX Lab’s success in serving over 30 million global shoppers through its Beyond app and BeyondStyle.us.
          </li>
        </ul>
        <p>
          <strong>Availability</strong>
        </p>
        <p>
          The OmniAgent Solution and CloudStore are now available for global merchants and shoppers on <Link to="/">Nubestore.ai</Link>, partners interested in joining the platform can sign up at <Link to="/contact-us">here</Link> for more information.
        </p>
        <p>
          <strong>About BorderX Lab</strong>
        </p>
        <p>
          Founded in 2014 by three former Google Ph.D. engineers, BorderX Lab is a Silicon Valley-based leader in cross-border e-commerce. Its flagship app, Beyond, and now the OmniAgent Solution on Nubestore.ai, empower global shoppers to access authentic products from top-tier U.S. and European retailers. With over 100 employees and partnerships with world-leading supply chain, logistics providers and payment solutions, BorderX Lab continues to innovate at the intersection of AI, Fashion and e-commerce.
        </p>
        <p>
          For more information, visit <a target="_blank" href="https://www.borderxlab.com/">www.borderxlab.com</a> or <a target="_blank" href="https://www.nubestore.ai">www.nubestore.ai</a>.
        </p>
        <p>
          <strong>Media Contact:</strong><br />
          Jessica / Tony <br />
          BorderX Lab <br />
          Email: <a href="mailto:jessica@borderxlab.com">jessica@borderxlab.com</a> / <a href="mailto:tony@borderxlab.com">tony@borderxlab.com</a> 
        </p>
      </>
    ),
  },
  {
    title: "Two Sides of AI Shopping Agent Checkout",
    backgroundColor: "#A3F4FF",
    subtitle:
      "At Google I/O event this past week, it was announced that Google Shopping’s agentic checkout will be available in a few months. Similarly, quite a few companies launched or limited launched ...",
    publishAt: "Published on May 30, 2025",
    image: agentCheckout,
    content: (
      <>
        <p>
          At Google I/O event this past week, it was announced that Google Shopping’s agentic checkout will be available in a few months. Similarly, quite a few companies launched or limited launched agentic checkout features including Amazon’s “Buy for Me” and Perplexity’s “Buy with Pro”. The age of AI shopping agents is coming. A big piece of AI shopping agents is the checkout. Before the Google I/O event, quite a few card networks and payment processor companies including Visa (<a target="_blank" href="https://corporate.visa.com/en/products/intelligent-commerce.html" rel="noreferrer">Intelligent Commerce</a>), Mastercard (<a target="_blank" href="https://www.mastercard.com/news/press/2025/april/mastercard-unveils-agent-pay-pioneering-agentic-payments-technology-to-power-commerce-in-the-age-of-ai/" rel="noreferrer">Agent Pay </a>), PayPal, and Stripe, announced the agentic payment innovation.
        </p>
        <p>
          BorderX Lab’s CloudStore AI product has been offering the agentic checkout API to our external clients for more than two years. This API has been used internally even longer to support shopping agents <a target="_blank" href="https://apps.apple.com/us/app/%E5%88%AB%E6%A0%B7%E6%B5%B7%E5%A4%96%E8%B4%AD-%E6%B5%B7%E6%B7%98%E4%B8%93%E5%AE%B6%E4%B8%80%E7%AB%99%E5%BC%8F%E6%9C%8D%E5%8A%A1/id947269781" rel="noreferrer">Beyond app</a>, a cross-border shopping assistant for Chinese consumers, and <a target="_blank" href="https://www.beyondstyle.us/" rel="noreferrer">BeyondStyle</a>, a price-discovery focused shopping assistant for American consumers, over a decade. This agentic checkout has successfully fulfilled $1,000,000,000 worth merchandising items such as Nike Sneakers and Lululemon yoga pants, and delivered 5,000,000 orders around the world. So CloudStore AI checkout API is a battle tested tool for AI shopping agents. We have accumulated a lot of operating experience with agentic checkout.  Here we like to emphasize there are two sides of AI shopping agent checkout. One side is the communication between humans/apps and the shopping agents. The other side is the communication between AI shopping agents and merchants. We observe that the communication between AI shopping agents and merchants are underdiscussed. We want to emphasize that both sides are equally important and affect the overall shopping experience greatly. On each side, we are dealing with different challenges. 
        </p>
        <p>
          One side is between humans/apps and the shopping agents. Recently many card network companies (e.g., Visa and Mastercard) and payment companies (e.g., Stripe and PayPal) announced agentic payment solutions for AI shopping agents. They are mostly focused on the security and trust between consumers/apps and AI shopping agents. For example, how much money will a consumer authorize an AI shopping agent to spend during agentic checkout. Based on our many years’ operating experience, we have served this side pretty well.  Our AI shopping agents are first-party AI shopping agents. We have fine-tuned authorization rules about AI shopping agents for a long time. For example, we optimize how much headroom we assign to AI shopping agents to deal with the unexpected price change on the merchant side. For third-party AI shopping agents, consumers/apps could not fully trust third-party AI shopping agents, at least in the beginning. Consumers have to clearly authorize AI shopping agents to do tasks with risk control in mind. 
        </p>
        <p>
          The other side is between AI shopping agents and merchants like <a target="_blank" href="https://www.wsj.com/articles/walmart-is-preparing-to-welcome-its-next-customer-the-ai-shopping-agent-6659ef18" rel="noreferrer">Walmart</a>. This is also a very important side of AI shopping agent checkout process. It is related to payment success, fulfillment success, logistics tracking, and many more. It greatly affects consumer’s shopping experience. For example, many merchants are deploying many mechanisms including reCAPTCHA to block orders from agents. If the AI shopping agents could not fulfill the orders at a high success rate, you can imagine how an AI shopping agent and a consumer will feel. Based on our many years of operating experience, we summarize two key metrics to consider when we evaluate the collaboration between AI shopping agents and merchants. 
        </p>
        <ul>
          <li>
            Payment Success Rate, i.e., what is the percentage of payment actions initiated by AI shopping agents that succeeds. AI shopping agents may fail to pay for many possible reasons including reCAPTCHA verficcation failure and IP address blocking.
          </li>
          <li>
            Fulfillment Success Rate, i.e., what is the percentage of orders successfully made by AI shopping agents that ships out. Merchants may cancel orders for many possible reasons such as out of inventory.
          </li>
        </ul>
        <p>
          Besides the payment collaboration between AI shopping agents and merchants, AI  shopping agents will also track the delivery time, merchandising item quality, and even reverse logistics. We believe that this side of AI shopping agent checkout is under-discussed while it is extremely important to drive the AI shopping agent’s wide adoption. 
        </p>
        <p>
          Contact us if you are interested in AI shopping agent checkout partnership or overall CloudStore AI collaboration.
        </p>
      </>
    ),
  },
  {
    title: "AI Price Hunter v2 - Exciting Improvement of \nAI shopping agent",
    backgroundColor: "#F5F5F5",
    subtitle:
      "Since we launched AI Price Hunter, the price-discovery AI shopping agent, early this year, we continue to make engineering and product innovation. We launched AI Price Hunter v2 in April...",
    publishAt: "Published on May 21, 2025",
    image: priceHunterV2,
    content: (
      <>
        <p>
          Since we launched AI Price Hunter, the price-discovery AI shopping agent, early this year, we continue to make engineering and product innovation. We launched AI Price Hunter v2 in April. I like to share the exciting improvements we have made in v2. 
        </p>
        <p>
          First, we improved agent reliability and accuracy. For the state-of-the-start AI shopping agent, it is a challenge to complete the increasingly complex and multi-step task all the time. We keep optimizing our workflow and test different foundation models. We have increased our SPU-level task completion rate to 80%. At the same time, we are optimizing our algorithm to improve hunting accuracy continuously. 
        </p>
        <p>
          Second, we enrich our data sources. The underlying data is always critical for any AI shopping agent. Besides leveraging our accumulated data set with tens of millions of merchandising items, we are also using external data sets. We qualitatively and quantitatively evaluate each external data set for our AI price hunter’s needs and spend a lot of effort curating the data sources. It is a time-consuming experiment and evaluation process. Hopefully, the AI price hunter can be the go-to price discovery agent for any consumers who are interested in price discovery in sports and fashion. Of course, the underlying AI price hunter can be adjusted for other shopping categories. 
        </p>
        <p>
          Third, we improved product design and provided API support for any merchant who is interested in AI price hunter service. We are happy to announce that CloudStore AI has included AI price hunter API. We have provided two package options, Hunter and Hunter Pro. Contact us for more information
        </p>
        <p>
          Fourth, we launched the interactive feature.  When people talk about AI agents, people often talk about automation and intelligence. Interaction is much less discussed. But interaction with human or other AI agents is a very important part for AI agents for complex and high-risk tasks such as purchasing a sneaker.  AI Price Hunter started this interactive journey early. See the screenshot below as a case of the AI Price Hunter <a href="https://www.beyondstyle.us/prod/nike-big-boys-jalen-brunson-blue-new-york-knicks-swingman-jersey-icon-edition?id=macys_16675102" target="_blank" rel="noreferrer">used in BeyondStyle</a>. The user can submit her hunting request to the AI price hunter. The AI price hunter will put their request in a queue. When the hunting is over, the AI price hunter will notify the user of the result. We call it the one-shot interactive version of AI price hunter. 
        </p>
        <div>
          <img src={priceHunterv2Product} alt="AI Price Hunter" />
        </div>
        <p>
          It is our decade work of transforming global commerce in making. Ten years ago, we embarked on a bold journey to revolutionize global commerce by making it automatic, intelligent, and interactive. Our vision has been clear from the start: 1-2-3 — automatic, intelligent, and interactive. Over the past decade, we’ve made remarkable strides:
        </p>
        <ul>
          <li>
            For 10 years, we’ve been automating global commerce, streamlining processes to make trade seamless through RPA (Robotic Process Automation) technology.
          </li>
          <li>
            For 8 years, we’ve been infusing intelligence into global commerce, leveraging cutting-edge technology to drive smarter decisions such as smart product recommendation.
          </li>
          <li>
            In 2024 , we’re taking a significant leap forward with the development of AI Shopping Agents, bringing a new level of intelligence (LLM technology in particular) to the shopping experience.
          </li>
          <li>
            And now, we’re just stepping into the future of interactive commerce by releasing a one-shot AI price hunter.
          </li>
        </ul>
        <p>
          We’re incredibly proud of how far we’ve come and excited about the road ahead. Here’s to continuing our mission of transforming global commerce for the better! 
        </p>
        <p>
          We are also looking for collaboration with other AI shopping agents to build the agentic AI together, the future of the multi-agent world.  Contact us if you are working in AI shopping agent space and looking for partnership. 
        </p>
      </>
    ),
  },
  {
    title: "AI Price Hunter for American Merchants in the Age of Tariff",
    backgroundColor: "#F1CEBC",
    subtitle:
      "The Trump administration launched a “Liberation Day” reciprocal tariff on April 2 and made a series of follow-up tariff announcements including a 145% tariff for goods made in China...",
    publishAt: "Published on Apr 16, 2025",
    image: americanMerchants,
    content: (
      <>
        <p>
          The Trump administration launched a “Liberation Day” reciprocal tariff
          on April 2 and made a series of follow-up tariff announcements
          including a 145% tariff for goods made in China. It brings a big
          challenge for American merchants. It is very hard for an American
          merchant to plan inventory beforehand and do pricing. They are facing
          a series of tough decisions. For example, whether they should pass the
          tariff to consumers or bear the burden themselves? How do their peer
          merchants make this decision for similar merchandising items?
        </p>
        <p>
          In addition to the fast pace of tariff development, the administration
          may back track or blink overnight, which generates additional
          uncertainty and unpredictability. For example, on late Friday, the
          administration exempted computers, semiconductors and electronics, as
          reported by <a target="_blank" className='anchor-bold' href="https://www.wsj.com/tech/trump-exempts-smartphones-other-electronics-from-chinese-tariffs-dd8eb31f" rel="noreferrer">WSJ</a> . It made fashion and sports merchants like Macy’s and
          Nike scratch their heads. Why does the administration not provide
          tariff exemption to apparel and sneakers? Which goods does the
          administration want onshore more, smartphone and electronics vs.
          apparel and sneakers? If apparel and sneakers are less a national
          security concern, should we exempt apparel and sneakers instead of
          computers and electronics? Does the carved out exemption this past
          Friday give people the impression that apparel, beauty, and sneakers
          are key industries that the US needs to onshore instead of computers,
          semiconductors, and electronics? American merchants, especially SME
          merchants, deserve more clarity and stability.
        </p>
        <p>
          During these extremely uncertain times, for American merchants in the
          fashion and sports category, AI Price Hunter is able to help the
          pricing planning. In particular, AI Price Hunter will help American
          merchants in two aspects of pricing planning. First, it will help
          American merchants do research on the pricing landscape given the
          selected SPU and provide the lowest price intelligence in the
          ecommerce space. Second, it will help American merchants do research
          on the pricing landscape of a competitor’s SPU and provide the lowest
          price intelligence in the ecommerce space.
        </p>
        <p>
          The AI Price Hunter is available to American merchants through
          CloudStore AI service as a part of CloudStore APIs. If you as an
          American merchant are interested in this service, please <Link  className='anchor-bold' to="/contact-us">contact us</Link>.
        </p>
      </>
    ),
  },
  {
    title:
      "AI Price Hunter: Price-Discovery focused AI Shopping Agent in the Age of Tariff",
    backgroundColor: "#F5F5F5",
    subtitle:
      "Trump’s administration's reciprocal tariff scared Wall Street last week. The $6T market cap is gone within two days[1].  The tariff will likely increase the price of merchandising items, especially...",
    publishAt: "Published on Apr 10, 2025",
    image: aiHunter,
    content: (
      <>
        <p>
          Trump’s administration's reciprocal tariff scared Wall Street last
          week. The $6T market cap is gone within two days
          <span className="scale">
            <span>[1]</span>
          </span>
          . The tariff will likely increase the price of merchandising items,
          especially physical items such as Coach fashion bags and Hoka
          sneakers. When American consumers do discretionary shopping, they will
          care more than ever about the price.
        </p>
        <p>
          In the age of tariff, we're happy to introduce the preview version of
          AI Price Hunter, a cutting-edge LLM-based AI Shopping Agent. AI Price
          Hunter is now available on BeyondStyle
          <span className="scale">
            <span>[2]</span>
          </span>
          , a client of CloudStore AI. Designed to assist fashion and sports
          shoppers with price discovery, this agent is here to transform the
          shopping experience: Given any merchandising item, AI Price Hunter
          will find the lowest price of that item on the Internet, regardless of
          whether BeyondStyle has an official merchant partnership with them or
          not.
        </p>
        <p>
          The preview version of BeyondStyle AI Price Hunter is in the format of
          AIGC as shown below. AI Price Hunter helps consumers discover the
          lowest price. This is especially useful for discretionary shopping
          such as fashion and sports shopping in the age of tariff.
        </p>
        <div>
          <img src={bsProduct} alt="AI Price Hunter" />
        </div>
        <p>
          We are working hard to improve our AI Price Hunter in the following
          three directions. First, we want to increase the AI agent reliability
          of AI Price Hunter. Our internal benchmark has shown a very
          encouraging baseline, but we continuously iterate. We aim at improving
          reliability significantly in the next 60 days. Second, we are
          experimenting with a variety of foundation models to seek the best
          balance between the quality and cost. On the cost side, imagine we
          will run AI Price Hunter for 10 million items each day, even though
          each run costs only $5 cents, we have to allocate a $500,000 budget
          PER DAY for AI Price Hunter in action, a significant amount of
          investment. On the quality side, we prefer the large language models
          which are natively multi-modal. We are optimizing AI agent performance
          with foundation models from all over the world including the USA and
          China. We are also optimizing agent performance with foundation models
          both closed sourced and open sourced. Third, we are making the AI
          price hunter more interactive with the consumers. It matches our
          mission well: make global commerce automatic, intelligent, and
          interactive.
        </p>
        <p>
          The AI Price Hunter will be available to more clients of CloudStore AI
          soon as a part of CloudStore APIs. We are looking forward to the wider
          adoption of AI Price Hunter. Please contact us
          <span className="scale">
            <span>[3]</span>
          </span>{" "}
          for more information if you are interested in the partnership.
        </p>
        <p>
          <a
            href="https://www.wsj.com/finance/stocks/u-s-stock-futures-fall-further-after-china-retaliates-against-trump-tariffs-3be33fa7"
            target="_blank"
            rel="noreferrer"
          >
            [1]
            https://www.wsj.com/finance/stocks/u-s-stock-futures-fall-further-after-china-retaliates-against-trump-tariffs-3be33fa7
          </a>
          <br />
          <a href="https://beyondstyle.us" target="_blank" rel="noreferrer">
            [2] https://beyondstyle.us
          </a>
          <br />
          <Link to="/contact-us">
            [3] https://www.nubestore.ai/#/contact-us
          </Link>
          <br />
        </p>
      </>
    ),
  },
  {
    title: "ROI of AI Shopping Agents",
    subtitle:
      "January, 2025 is a hectic month for AI development. The biggest development is Deepseek’s shock, which brought down $1T US stock value,  although the Deepseek-R1 model was actually...",
    backgroundColor: "#CBB9FF",
    publishAt: "Published on Feb 7, 2025",
    image: roiAi,
    content: (
      <>
        <p>
          January, 2025 is a hectic month for AI development. The biggest
          development is Deepseek’s shock, which brought down $1T US stock
          value, although the Deepseek-R1 model was actually released in late
          December, 2024. As the previous{" "}
          <a
            target="_blank"
            href="https://www.nubestore.ai/#/blog/cloudstore-a-tool-for-ai-shopping-agents"
            rel="noreferrer"
          >
            article
          </a>
          [1] mentioned, foundation models can be US-based models or China-based
          models. Foundation models can also be closed models or open models.
          Deepseek’s shock involved both these two dimensions. But besides these
          two dimensions, there is an extremely important third dimension, i.e.,
          cost or economics dimension. DeepSeek training cost (or the last
          training run) is $6M, while many state of the art models training cost
          is a few $10M’s [2] to $1B ($1B may be a tactic to scare away
          competitors, but obviously it backfired). It is clear now that the
          training cost can definitely be{" "}
          <strong>cheaper, much cheaper, and at least 10x cheaper</strong>. When
          something is 10x cheaper , it is a big change and people will try it
          and adopt it. As we build and empower AI shopping agents, we cheer on
          models which are more powerful, more widely adopted, and cheaper.
          Lower cost means better ROI opportunities for AI application builders
          such as AI shopping agent builders.
        </p>
        <p>
          For AI shopping agent builders, we care more about what is the cost of
          utilizing foundation models and what is ROI after we deploy AI
          shopping agents in the production. To utilize foundation models, we
          have two ways. One is to call the foundation model APIs directly. The
          other is to deploy an open model ourselves. For the foundation model
          API calls, i.e. inference, DeepSeek APIs are{" "}
          <strong>cheaper, much cheaper, and at least 10x cheaper</strong>.
          Check the latest pricing on these model providers’ websites. There may
          be a price war, which is good for AI shopping agent builders. Many
          people try to deploy open models themselves on cloud or local servers
          to further save the utilization cost. Last week, we saw people deploy
          the DeepSeek model on a $6000 local server. On January 31, we even saw
          people deploy the DeepSeek model on a $2000 local server [3]. The
          entry point for AI shopping agent builders is getting lower and lower.
          More people can join to build AI shopping agents, which is exciting
          news!
        </p>
        <p>
          Lower cost of utilizing foundation models is great news for AI
          shopping agent builders. But it is not enough. We have to make a{" "}
          <strong>real business impact</strong> when we deploy AI shopping
          agents in the production. If the core value of the AI shopping agent
          we build is to automate the shopping tasks, the AI shopping agent must
          save money than the previous non-AI way, i.e., the AI shopping agent
          must bring positive ROI in order to get wider adoption. If the cost of
          calling foundation model APIs alone is bigger than hiring a human to
          do the shopping tasks or using RPA (Robotic Programming Automation) to
          do the shopping tasks, the AI shopping agent will definitely not be
          widely adopted. We have to optimize the cost of calling the foundation
          model APIs. There are many possible ways to optimize the cost of
          calling the foundation model APIs. Here are three ways. The first is
          to call cheaper but decent quality foundation models such as
          DeepSeek-R, which is at least 10x cheaper. The second is to optimize
          the input tokens before we make API calls[4]. The third is to generate
          code once for all when we make foundation API calls. Then when we plan
          to make foundation API calls next time, execute the generated code
          instead of calling foundation model APIs to fulfill the task[4].
        </p>
        <p>
          <a
            href="https://www.nubestore.ai/#/blog/cloudstore-a-tool-for-ai-shopping-agents"
            target="_blank"
            rel="noreferrer"
          >
            [1]
            https://www.nubestore.ai/#/blog/cloudstore-a-tool-for-ai-shopping-agents
          </a>
          <br />
          <a
            href="https://darioamodei.com/on-deepseek-and-export-controls"
            target="_blank"
            rel="noreferrer"
          >
            [2] https://darioamodei.com/on-deepseek-and-export-controls
          </a>
          <br />
          <a
            href="https://www.youtube.com/watch?v=Tq_cmN4j2yY"
            target="_blank"
            rel="noreferrer"
          >
            [3] https://www.youtube.com/watch?v=Tq_cmN4j2yY
          </a>
          <br />
          <a
            href="https://www.zyte.com/webinars/efficient-web-scraping-with-llms/"
            target="_blank"
            rel="noreferrer"
          >
            [4] https://www.zyte.com/webinars/efficient-web-scraping-with-llms/
          </a>
          <br />
        </p>
      </>
    ),
  },
  {
    title: "CloudStore, a tool for AI Shopping Agents",
    subtitle:
      "AI agent is a term which has been used for decades. But here we are talking about an AI agent with a large language model. So you are making or plan to make an AI shopping agent by leveraging...",
    backgroundColor: "#F5F5F5",
    publishAt: "Published on Jan 27, 2025",
    image: shoppingTools,
    content: (
      <>
        <p>
          AI agent is a term which has been used for decades. But here we are
          talking about an AI agent with a large language model. So you are
          making or plan to make an AI shopping agent by leveraging a large
          language model (LLM). You have probably already decided which LLM
          model(s) to use, closed models such as Anthropic or Gemini, vs. open
          models such as Llama or Mistral, US-based models such as OpenAI or
          xAI, vs. international models such as DeepSeek or Alibaba’s Qwen. But
          as Google AI agent whitepaper[1] mentioned, you probably need to
          integrate with some tools in order to make AI shopping agents do
          amazing things for your customers.
        </p>
        <p>
          It is likely that you are focused on how to utilize LLMs to build an
          awesome agent and you need some external tools to help you do some
          shopping errands such as getting a merchandising catalog and making an
          order. You are not interested in doing this ecommerce plumbing work.
          Fortunately, there are some tools in the markets already available for
          this. CloudStore is such a tool. What can CloudStore do to empower
          your exciting AI shopping agent innovation?
        </p>
        <p>Here are 3 must-haves for your AI shopping agent.</p>
        <ul>
          <li>
            <strong>Catalog API.</strong> You can easily get a merchandising
            catalog from more than 300 merchants, 6000 American and European
            brands, and 10,000,000 merchandising SKUs. You do not need to find
            ways to find this huge merchandising supply since we have been
            building this in the last 10 years and we keep adding supplies and
            improving the quality of this merchandising catalog such as data
            freshness.
          </li>
          <li>
            <strong>Order API.</strong> If you are truly a shopping agent, one
            action is a must-have, i.e., order a product, say, a pair of
            sneakers for your customers. Ordering sounds simple, but it is messy
            engineering work in reality. Fortunately, CloudStore has
            successfully made 5,000, 000 orders and delivered more than
            $1,000,000,000 worth merchandising items for clients all over the
            world (USA, China, South Korea, Australia, South America, etc.).
          </li>
          <li>
            <strong>Logistics tracking API.</strong> Your AI shopping agent may
            keep customers informed about where ordered merchandising items are
            located. Logistics tracking API enables your AI shopping agent and
            your customers to know the step-by-step journey of merchandising
            items, maybe from the other side of the world, say, Manchester of UK
            to the doorstep of your customer home in Los Angeles, California. We
            have accumulated shipping performance data over 10 years and know
            which merchants to recommend.
          </li>
        </ul>
        <p>
          In addition, there are some additional tools such as Search API. If
          your shopping agent needs the search feature among 10,000,000+
          merchandising items and you do not want to focus on this feature, you
          do not need to reinvent the wheel since CloudStore already offer the
          search API.
        </p>
        <p>
          We strongly believe in the bright future of AI shopping agents.
          Different AI shopping agent innovation may cover the whole path of the
          shopping journey or only a part of the shopping journey. It may also
          get humans involved in the loop, as Langchain calls ambient agents[2].
          But no matter what, CloudStore will provide a strong toolkit to AI
          shopping agents to fulfill the shopping errands in the whole shopping
          journey.
        </p>
        <p>
          <a
            href="https://www.kaggle.com/whitepaper-agents"
            target="_blank"
            rel="noreferrer"
          >
            [1] https://www.kaggle.com/whitepaper-agents
          </a>
          <br />
          <a
            href="https://blog.langchain.dev/introducing-ambient-agents/"
            target="_blank"
            rel="noreferrer"
          >
            [2] https://blog.langchain.dev/introducing-ambient-agents/
          </a>
        </p>
      </>
    ),
  },
  {
    title: "AI Shopping Agent \nin 2025",
    backgroundColor: "#DCFF9B",
    subtitle:
      "The Age of AI Agents is here. AI shopping agents are evolving fast. Perplexity, Amazon (Rufus), and many other players are developing AI shopping agents or assistants. ",
    publishAt: "Published on Jan 15, 2025",
    image: aiShoppingAgent,
    content: (
      <>
        <p>
          The Age of AI Agents is here. AI shopping agents are evolving fast.
          Perplexity, Amazon (Rufus), and many other players are developing AI
          shopping agents or assistants.
        </p>
        <p>
          As consumer-facing agents, AI shopping agents or travel agents are
          more complex than enterprise-facing agents because of heterogeneity of
          consumer applications and complexity of understanding consumers. In
          order to prepare for a better future for the AI shopping agent world,
          we encourage ecommerce merchants to set a standard and open protocol
          about ecommerce infrastructure such as product catalog and order
          fulfillment.  It will accelerate AI shopping agent progress and
          improve agent accuracy. 
        </p>
        <p>
          The expectations for AI shopping agents or assistants span a broad
          spectrum, from basic tasks to sophisticated operations. CloudStore AI
          (
          <a target="_blank" href="https://www.nubestore.ai/" rel="noreferrer">
            https://www.nubestore.ai/
          </a>
          ) of BorderX Lab has emerged as a comprehensive tool to support these
          AI shopping agents across the entire shopping journey - from managing
          product catalogs, fulfilling orders, to tracking logistics, and
          handling returns.
        </p>
        <p>
          Ecommerce needs a lot of plumbing work, order fulfillment, logistics
          tracking, and return processing. Humans are definitely in the loop now
          for AI shopping agents. The work distribution of humans and AI is
          evolving. Eventually AI shopping agents can have the same skills as
          humans.
        </p>
        <p>Now is an exciting time to build AI shopping agents.</p>
      </>
    ),
  },
  {
    title: "AI Online Shopping Agents: The Future of E-commerce",
    backgroundColor: "#FAFAFA",
    subtitle:
      "The rapid advancements in AI, particularly with Large Language Models (LLMs), have made the development of AI Online Shopping Agents (AIOSAs) a real possibility. While online...",
    publishAt: "Published on Jan 14, 2025",
    image: aiOnlineShopping,
    content: (
      <>
        <p>
          The rapid advancements in AI, particularly with Large Language Models
          (LLMs), have made the development of AI Online Shopping Agents
          (AIOSAs) a real possibility. While online shopping is a common task
          for many, a successful purchase often requires significant time and
          effort. For instance, finding the perfect desk for my 8-year-old
          daughter on Amazon took nearly an hour. I had to compare multiple
          products, understand their features, read customer reviews, and select
          the right size and color. Even after receiving the item, there might
          be additional tasks if I'm unsatisfied with the purchase.
        </p>
        <p>
          In the foreseeable future, AI Online Shopping Agents can assist us in
          completing successful online shopping trips and save us time, energy,
          and money. For those who struggle with internet use, such as the
          elderly, the benefits would be even more pronounced.
        </p>
        <p>
          However, developing an AI Online Shopping Agent is not a trivial task.
          It presents several challenges:
        </p>
        <ul>
          <li>
            <strong>Interacting with the Internet:</strong> AI must be able to
            interact with the internet as humans do. While recent advancements
            in AI agents, like Anthropic's computer use, have made strides,
            there's still room for improvement.
          </li>
          <li>
            <strong>Domain Knowledge:</strong> AI needs to possess
            domain-specific knowledge about shopping. It's not inherently
            knowledgeable about every aspect of shopping. Each step in the
            shopping process requires prompts to guide the AI, telling it which
            websites to visit, tools to use, and so on.
          </li>
          <li>
            <strong>Human Interaction:</strong> AI must effectively interact
            with humans, following human guidance and making decisions under
            human supervision.
          </li>
          <li>
            <strong>Safety and Security:</strong> With AI hallucinations still
            being an issue, ensuring the accuracy and security of AI-driven
            actions is crucial.
          </li>
        </ul>
        <p>
          Given these challenges, we believe the development of AI Online
          Shopping Agents will be a gradual process. In the early stages,
          critical steps like placing orders may still require human-AI
          collaboration.
        </p>
        <p>
          At BorderX Lab, we're actively researching and developing AI Online
          Shopping Agents. With a decade of experience in e-commerce and RPA
          services, we're confident in the potential of AI Online Shopping
          Agents and believe we're well-positioned to succeed. For example, our
          cloud store product (
          <a target="_blank" href="https://www.nubestore.ai/" rel="noreferrer">
            https://www.nubestore.ai/
          </a>
          ) leverages RPA to automate order placement on major European and
          American fashion e-commerce sites with a success rate of 95%. This
          service can seamlessly integrate with AI to create AI Online Shopping
          Agents specifically for fashion e-commerce.
        </p>
      </>
    ),
  },
  {
    title:
      "AI Shopping Agents: Unlocking the Secrets of a Perfect Shopping Experience",
    backgroundColor: "#A3F4FF",
    subtitle:
      "Imagine a future where you wake up, and your AI shopping agent, integrated with your smart home system, has already analyzed the data from your smart fitness tracker. It knows you've been ...",
    publishAt: "Published on Jan 13, 2025",
    image: shoppingExperience,
    content: (
      <>
        <p>
          Imagine a future where you wake up, and your AI shopping agent,
          integrated with your smart home system, has already analyzed the data
          from your smart fitness tracker. It knows you've been pushing yourself
          hard at the gym, and as you enter the kitchen, a holographic display
          appears, showing you the latest high - performance sports gear that's
          perfect for your workouts. When you're getting ready for a virtual
          business meeting, the AI, having studied your past meeting outfits and
          the nature of the event, suggests a stylish, professional ensemble
          that can be ordered and delivered within hours. As you commute, the
          agent notifies you of a limited - edition art piece that matches your
          home decor preferences, and with a simple voice command, you can add
          it to your cart.
        </p>
        <p>
          Are these the kind of shopping experiences we all desire? In recent
          years, AI shopping agents have emerged as a revolutionary force within
          the dynamic e - commerce landscape. Giants like Amazon, leveraging the
          power of Alexa. Similarly, Alibaba, with its cutting - edge smart
          shopping assistants, has been leading the charge in the East. Their AI
          can not only understand complex natural language queries but also
          provide astute product recommendations. It can even smoothly complete
          purchases, making the shopping process as seamless as possible.
        </p>
        <p>
          However, this is just the tip of the iceberg. There remains an ocean
          of untapped potential for further development, such as enhancing the
          agents' ability to handle more nuanced emotions in customer requests
          and integrating with emerging technologies like augmented reality for
          a more immersive shopping experience.
        </p>
        <p>
          What sets BorderX Lab's Cloud Store apart from its competitors is
          truly extraordinary. It has established an incredibly robust fashion
          supply chain in both Europe and the United States. For instance, when
          Paris Fashion Week debuts the latest trends, the Cloud Store's AI
          shopping agents can quickly offer customers those exclusive pieces.
          This means fashion enthusiasts can get their hands on the most up - to
          - date and unique fashion items straight from these fashion - forward
          regions.
        </p>
        <p>
          The Cloud Store also houses a colossal database that towers over many
          others in the industry. It doesn't stop at fashion; it encompasses a
          broad range of products, from electronics to home decor. With real -
          time price and inventory updates, the AI agents ensure that customers
          are always in the know. No more disappointment of clicking on a
          product only to find it's out of stock or being charged an incorrect
          price.
        </p>
        <p>
          Moreover, its personalized data analytics are unrivaled. By delving
          deep into customers' shopping habits, preferences, and even style
          choices, the AI agents can offer customized recommendations like no
          other, creating a shopping experience that is uniquely tailored to
          each individual.
        </p>
        <p>
          The Cloud Store will serve as a huge product data repository. For
          instance, when a user searches for a high - end smartphone, the AI
          agent, leveraging the Cloud Store's data, can instantly list all
          available models from different brands, their features like camera
          quality, processing speed, and battery life, along with price
          comparisons across multiple online platforms.
        </p>
        <p>
          Advanced algorithms in the Cloud Store analyze customers' behaviors.
          Suppose a customer often buys fitness equipment. The AI agent can then
          suggest new yoga mats from emerging eco - friendly brands added to the
          Cloud Store, complete with user reviews.
        </p>
        <p>
          Moreover, for cross - border shopping, if a customer in the US wants
          to buy Japanese skincare products, the agent, using the Cloud Store's
          global network, can handle currency conversion, find the best - priced
          products, and sort out shipping details. This makes shopping more
          efficient and globally accessible.
        </p>
      </>
    ),
  },
].map((item) => ({
  ...item,
  id: normalizeTerm(item.title),
}));

export default articles;